import thumbDownIcon from '@iconify/icons-material-symbols/thumb-down-outline-rounded';
import thumbDownFilledIcon from '@iconify/icons-material-symbols/thumb-down-rounded';
import thumbUpIcon from '@iconify/icons-material-symbols/thumb-up-outline-rounded';
import thumbUpFilledIcon from '@iconify/icons-material-symbols/thumb-up-rounded';
import { Icon } from '@iconify/react';
import { IconButton, Stack } from '@mui/material';
import React from 'react';

import useLocales from 'hooks/useLocales';

interface ChatMessageRatingProps {
    rating?: 1 | -1;
    disabled: boolean;
    // Clicking the chosen thumb again takes the rating back (null).
    onRate: (rating: 1 | -1 | null) => void;
}

const ChatMessageRating: React.FunctionComponent<ChatMessageRatingProps> = ({ rating, disabled, onRate }) => {
    const { translate } = useLocales();
    return (
        <Stack direction='row' spacing={0.25}>
            <IconButton
                size='small'
                disabled={disabled}
                aria-pressed={rating === 1}
                aria-label={translate('chat_rate_up')}
                onClick={() => onRate(rating === 1 ? null : 1)}
                color={rating === 1 ? 'primary' : 'default'}
            >
                <Icon icon={rating === 1 ? thumbUpFilledIcon : thumbUpIcon} width={16} height={16} />
            </IconButton>
            <IconButton
                size='small'
                disabled={disabled}
                aria-pressed={rating === -1}
                aria-label={translate('chat_rate_down')}
                onClick={() => onRate(rating === -1 ? null : -1)}
                color={rating === -1 ? 'primary' : 'default'}
            >
                <Icon icon={rating === -1 ? thumbDownFilledIcon : thumbDownIcon} width={16} height={16} />
            </IconButton>
        </Stack>
    );
};

export default ChatMessageRating;
